// Mobile bottom tab nav. Hidden on md+. Switches between Map and Table
// in the main pane. Settings drawer is opened separately via the header.
export default function BottomTabs({ tab, onChange }) {
  return (
    <nav className="md:hidden flex border-t border-slate-800 bg-slate-900">
      <TabBtn active={tab === 'map'} onClick={() => onChange('map')}
              icon={<MapIcon />} label="Map" />
      <TabBtn active={tab === 'table'} onClick={() => onChange('table')}
              icon={<TableIcon />} label="Spots" />
    </nav>
  );
}

function TabBtn({ active, onClick, icon, label }) {
  return (
    <button
      onClick={onClick}
      className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-xs ${
        active ? 'text-cyan-400' : 'text-slate-500 hover:text-slate-300'}`}>
      {icon}
      <span>{label}</span>
    </button>
  );
}

function MapIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10" />
      <path d="M2 12h20M12 2a15 15 0 0 1 0 20M12 2a15 15 0 0 0 0 20" />
    </svg>
  );
}

function TableIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="18" height="18" rx="1" />
      <path d="M3 9h18M3 15h18M9 3v18" />
    </svg>
  );
}
